<template>
    <div class="animated fadeIn dashboard dashboard-administracion">
      <b-row>
        <b-col sm="6" lg="4">
          <app-indicador-compras-ventas
            ref="indicadorComprasVentas">
          </app-indicador-compras-ventas>
        </b-col>

        <b-col sm="6" lg="4">
          <app-indicador-gastos-ventas
            ref="indicadorGastosVentas">
          </app-indicador-gastos-ventas>
        </b-col>

        <b-col sm="6" lg="4">
          <app-indicador-diferencia-plazos
            ref="indicadorDiferenciaPlazos">
          </app-indicador-diferencia-plazos>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6" lg="4">
          <app-indicador-plazos-cobros
            ref="indicadorPlazosCobros">
          </app-indicador-plazos-cobros>
        </b-col>
        <b-col sm="6" lg="4">
          <app-indicador-plazos-pagos
            ref="indicadorPlazosPagos">
          </app-indicador-plazos-pagos>
        </b-col>
      </b-row>

      <hr class="dashboard">

      <b-row>
        <b-col sm="5" lg="5">
          <div class="dashboard-chart dashboard-chart-formas-pago">
            <h4>Formas de Pago</h4>
            <p class="description">Últimos 12 meses</p>
            <pie ref="formaPago"></pie>
            <label class="description">Excluye retenciones y pago de impuestos</label>
            <p class="link" 
              @click.stop="exportarProveedores"><i class="fa fa-file-excel-o"></i>Exportar Resultados por Proveedor</p>
          </div>
        </b-col>
        <b-col sm="7" lg="7">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="resultadosFormaPago" 
              :fields="resultadosFormaPagoFields">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>
            <template v-slot:cell(color)="data">
                <div class="color-reference" :style='"background-color: " + getColor(data.item) + ";"'></div>              
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda }}
            </template>
            <template v-slot:cell(pjeParticipacion)="data">
              {{ data.item.pjeParticipacion | porcentaje }}
            </template>
          </b-table>
        </b-col>
      </b-row>

      <hr class="dashboard">

      <b-row>
        <b-col sm="12" lg="12">
          <app-cheques-propios
            ref="chequesPropios">
          </app-cheques-propios>
        </b-col>
      </b-row>

      <hr class="dashboard">

      <b-row>
        <b-col sm="12" lg="12">
          <app-deuda-clientes
            ref="deudaClientes">
          </app-deuda-clientes>
        </b-col>
      </b-row>

      <hr class="dashboard">

      <b-row>
        <b-col sm="12" lg="12">
          <app-evolucion-empresa
            ref="evolucionEmpresa">
          </app-evolucion-empresa>
        </b-col>
      </b-row>

      <hr class="dashboard">

      <b-row>
        <b-col sm="12" lg="12">
          <app-evolucion-rn
            ref="evolucionRN">
          </app-evolucion-rn>
        </b-col>
      </b-row>

      <hr class="dashboard">

      <b-row class="evolucion-intereses">
        <b-col sm="12" lg="12">
          <div class="dashboard-chart">
            <h4>Evolución de Intereses Bancarios</h4>
          </div>
          <line-evolucion-intereses
            chartId="evolucion-intereses" 
            class="chart-wrapper"
            ref="evolucionIntereses">
          </line-evolucion-intereses>
        </b-col>
      </b-row>

      <hr class="dashboard">

      <b-row>
        <b-col sm="12" lg="12">
          <app-evolucion-plazos-pago
            ref="evolucionPlazosPago">
          </app-evolucion-plazos-pago>
        </b-col>
      </b-row>

      <app-mensaje
        :modalMsj="modalMsj"
        :modalMensaje="modalMensaje"
        @okAction="okAction"
        @hiddenAction="hiddenAction">
      </app-mensaje>
    </div>
</template>

<script>
// import IndicadorGastos from './IndicadorGastos';
import IndicadorGastosVentas from './IndicadorGastosVentas';
import IndicadorComprasVentas from './IndicadorComprasVentas';
import IndicadorPlazosPagos from './IndicadorPlazosPagos';
import IndicadorPlazosCobros from './IndicadorPlazosCobros';
import IndicadorDiferenciaPlazos from './administracion/IndicadorDiferenciaPlazos.vue';
import Pie from '../charts/Pie';
import ChequesPropios from './administracion/ChequesPropios';
import DeudaClientes from './administracion/DeudaClientes';
import EvolucionEmpresa from './administracion/EvolucionEmpresa';
import LineEvolucionIntereses from '../charts/LineEvolucionIntereses.vue';
import EvolucionRn from './administracion/EvolucionRN';
import EvolucionPlazosPago from './administracion/EvolucionPlazosProveedores';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'

export default {
  components: {
    // appIndicadorGastos: IndicadorGastos,
    appIndicadorGastosVentas: IndicadorGastosVentas,
    appIndicadorComprasVentas: IndicadorComprasVentas,
    appIndicadorPlazosPagos: IndicadorPlazosPagos,
    appIndicadorPlazosCobros: IndicadorPlazosCobros,
    appIndicadorDiferenciaPlazos: IndicadorDiferenciaPlazos,
    appChequesPropios: ChequesPropios,
    appDeudaClientes: DeudaClientes,
    appEvolucionEmpresa: EvolucionEmpresa,
    appEvolucionRn: EvolucionRn,
    appEvolucionPlazosPago: EvolucionPlazosPago,
    LineEvolucionIntereses,
    Pie,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],

data() {
    return {
      resultadosFormaPago: [],
      resultadosFormaPagoFields: [
        { 
          key: 'color',
          label: 'Ref.'
        },
        { key: 'formaPago' },
        { 
          key: 'importe',
          class: 'text-right'
        },
        { 
          key: 'pjeParticipacion',
          class: 'text-right'
        },
      ],

      key: 0,
      tableBusy: false,
    }
  },
  beforeDestroy() {
    console.log('beforeDestroy');
    this.$refs.indicadorGastosVentas.cancelar();
    this.$refs.indicadorComprasVentas.cancelar();
    this.$refs.indicadorPlazosPagos.cancelar();
    this.$refs.indicadorPlazosCobros.cancelar();
    this.$refs.indicadorDiferenciaPlazos.cancelar();
  },  
  methods: {
    getIndicadores() {
      this.$refs.indicadorGastosVentas.getIndicador();
      this.$refs.indicadorComprasVentas.getIndicador();
      
      this.$store.dispatch('resultadosAdministracion/inicializar')
        .then(() => {
          this.$refs.indicadorPlazosCobros.getIndicador()
          this.$refs.indicadorPlazosPagos.getIndicador();
          this.$refs.indicadorDiferenciaPlazos.getIndicador();
          this.$refs.deudaClientes.getResultados()
          this.$refs.chequesPropios.getResultados()

          this.$store.dispatch('resultadosAdministracion/getResultadosFormaPago')
            .then(() => {
              this.resultadosFormaPago = this.$store.getters['resultadosAdministracion/resultadosFormaPago'];
              let labels = this.$store.getters['resultadosAdministracion/resultadosFormaPagoLabels'];
              let colors = this.$store.getters['resultadosAdministracion/resultadosFormaPagoColors'];
              let data = this.$store.getters['resultadosAdministracion/resultadosFormaPagoData'];

              this.$refs.formaPago.render(labels, colors, data, false);
            });

          this.$store.dispatch('resultadosAdministracion/getEvolucionIntereses')
            .then(() => {
              let labels = this.$store.getters['resultadosAdministracion/resultadosEvolucionInteresesPeriodos'];
              let data = this.$store.getters['resultadosAdministracion/resultadosEvolucionIntereses'];
              let max = this.$store.getters['resultadosAdministracion/resultadosEvolucionInteresesMax'];
              let stepSize = this.$store.getters['resultadosAdministracion/resultadosEvolucionInteresesStep'];
              this.$refs.evolucionIntereses.render(labels, data, max, stepSize);
            });
          
          this.$refs.evolucionEmpresa.getEvolucion();
        });

        this.$refs.evolucionRN.getEvolucion();

        this.$refs.evolucionPlazosPago.getEvolucion();
    },
    getColor(item) {
      return item.color;
    },
    // indicadorPlazosPagosInicializado() {
    //   this.$refs.indicadorDiferenciaPlazos.getIndicador()
    // },
    // indicadorPlazosCobrosInicializado() {
    //   this.$refs.indicadorDiferenciaPlazos.getIndicador()
    // },
    exportarProveedores() {
      this.showSpinner();
      this.$store.dispatch('resultadosAdministracion/getResultadosFormaPagoProveedores')
        .then(() => {
          let exportXls = Boolean(false); 
          let proveedores = this.$store.getters['resultadosAdministracion/resultadosFormaPagoProveedores'];

          if (proveedores) {
            if (proveedores.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Formas de Pago por Proveedor';
            let fileName = 'formas-pago-proveedores';
            let format = [
              { titulo: 'Proveedor', nombre: 'proveedor', formato: '' },
              { titulo: 'Pesos', nombre: 'importePesos', formato: '' },
              { titulo: 'Pje.Pesos', nombre: 'pjePesos', formato: '' },
              { titulo: 'Cheques Propios', nombre: 'importeChequesPropios', formato: '' },
              { titulo: 'Pje.Cheques Propios', nombre: 'pjeChequesPropios', formato: '' },
              { titulo: 'Transferencias', nombre: 'importeTransferencias', formato: '' },
              { titulo: 'Pje.Transferencias', nombre: 'pjeTransferencias', formato: '' },
              { titulo: 'Tarjetas', nombre: 'importeTarjetas', formato: '' },
              { titulo: 'Pje.Tarjetas', nombre: 'pjeTarjetas', formato: '' },
            ];

            this.exportXLS(title, fileName, proveedores, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    }
  }
}
</script>

<style>
  .dashboard-administracion .row {
    margin-bottom: 30px;
  }
  .dashboard-administracion .dashboard-chart > div {
    position: relative;
    padding-left: 10%;
    padding-right: 10%;
    padding-bottom: 10%;    
    /* top: 20px;
    padding-left: 20px;
    padding-right: 20px; */
  }
  .dashboard-administracion .dashboard-chart.dashboard-chart-formas-pago h4 {
    margin-bottom: 5px !important;
  }
  .dashboard-chart .description {
    font-size: 12px;
    font-style: italic;
  }

  .dashboard-administracion table {
    position: relative;
    top: 20px;
  }
  .dashboard-administracion table thead th {
    border-top: none;
  }
  .dashboard-administracion table tbody tr td {
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .dashboard-administracion table .color-reference {
    display: inline-block;
    position: relative;
    /* margin-right: 5px; */
    width: 24px; 
    height: 12px; 
    top: 2px;
  }

  .dashboard-administracion .dashboard-chart p.link {
    font-size: 0.8em;
    font-style: italic;
    cursor: pointer;
  }
  .dashboard-administracion .dashboard-chart p.link i {
    margin-right: 5px;
  }

  .dashboard-administracion .evolucion-intereses .chart-wrapper {
    position: relative;
    height: 350px;
  }
</style>


